import React, { useCallback, useEffect, useState } from "react";

import moment from "moment";

import { getAlerts } from "services";

import { getEnvironment, getLocalKlimVar, useAdminUserContext, useCancelAsyncOnUnmount, useToggleNavs, useTranslation } from "utils";

import { AdminHead, AdminRolesDrawer, Alert, Button, Col, Link, MainPage, Row, Typography } from "components";

import { Alerts } from "pages/admin/dashboard/Alerts";

export const Dashboard = () => {
  const { t } = useTranslation(["scores"]);

  const [showDrawer, setShowDrawer] = useState(false);
  const [alerts, setAlerts] = useState(false);
  const [loading, setLoading] = useState(true);
  const signal = useCancelAsyncOnUnmount()();
  const env = getEnvironment();

  const { user } = useAdminUserContext();

  useToggleNavs(true, false);

  const loadAlerts = useCallback(() => {
    getAlerts({
      signal,
    })
      .then((res) => {
        setAlerts(res);
      })
      .catch(() => {
        // Guest logins are not allowed to read the alerts, so render the dashboard without them
        // rather than leaving an unhandled rejection behind.
        setAlerts([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    if (getLocalKlimVar("token")) {
      loadAlerts();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage
      loading={loading}
      pageName={"admin"}
      beforePage={
        (env.staging || env.development || env.local) && (
          <Alert
            className="alert-banner center sticky"
            description="You are using a staging environment. All features and data is subject to bugs, changes or deletion at any time without notice."
            icon=""
            closable={false}
            style={{ cursor: "pointer", backgroundColor: "#ff845e" }}
          />
        )
      }
    >
      {!loading && user && (
        <>
          <section className="admin container padded" id="dashboard">
            <AdminHead
              headline={
                <>
                  Hi {user.firstName}. Happy {moment().format("dddd")}!
                </>
              }
              description={
                <>
                  You have {user.role} access rights.{" "}
                  <Link tracking={false} onClick={() => setShowDrawer(true)}>
                    View admin role details
                  </Link>
                </>
              }
            />
            <Row>
              <Col>
                <Typography variant="h3">The gremlins want you to check these things...</Typography>
              </Col>
            </Row>
            <Alerts alerts={alerts} />
            <Row className="margin-top-200">
              <Col sm={12}>
                <Button
                  type="primary"
                  mixpanelText={t("letsTalk.joinDemo")}
                  onClick={() => {
                    window.open("https://klim.metabaseapp.com/dashboard/78-credit-cockpit-new");
                  }}
                >
                  Credit Cockpit
                </Button>
              </Col>
              <Col sm={12}>
                <Button
                  type="secondary"
                  mixpanelText={t("letsTalk.joinDemo")}
                  onClick={() => {
                    window.open("https://docs.google.com/document/d/1m5B9S6QN2lh9kLyeu6Cgz-1ZEUvf-fxwA0LBUWzDlh4/edit#");
                  }}
                >
                  Instructions
                </Button>
              </Col>
            </Row>
          </section>
          <AdminRolesDrawer visible={showDrawer} onClose={() => setShowDrawer(false)} />
        </>
      )}
    </MainPage>
  );
};
